import React from "react";
import {
  GraduationCap, BadgeCheck, ShieldCheck, Cpu, Network, Leaf,
} from "lucide-react";
import { FEATURES } from "../data/mock";

const ICONS = { GraduationCap, BadgeCheck, ShieldCheck, Cpu, Network, Leaf };

export default function Features() {
  return (
    <section className="relative py-20 md:py-28 bg-gradient-to-b from-white via-[#f5f7ff] to-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {FEATURES.map((f, i) => {
            const Icon = ICONS[f.icon] || GraduationCap;
            return (
              <div
                key={f.title}
                className="reveal group relative rounded-2xl bg-white border border-slate-200/80 p-7 lift overflow-hidden"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="absolute -top-12 -right-12 h-32 w-32 rounded-full bg-[#f59e0b]/10 blur-2xl group-hover:bg-[#f59e0b]/20 transition-colors"></div>
                <div className="relative">
                  <div className="h-12 w-12 rounded-xl bg-[#102a6b] text-white flex items-center justify-center shadow-md shadow-[#102a6b]/20 group-hover:bg-[#0a1f55] transition-colors">
                    <Icon className="h-5.5 w-5.5" strokeWidth={2} />
                  </div>
                  <h3 className="mt-5 text-xl font-bold text-[#0a1f55] leading-snug">{f.title}</h3>
                  <p className="mt-2 text-[14.5px] text-slate-600 leading-relaxed">{f.text}</p>
                  <div className="mt-5 h-[3px] w-10 rounded-full bg-gradient-to-r from-[#102a6b] to-[#f59e0b] group-hover:w-20 transition-all duration-500"></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
